import { computed } from 'vue'
// types
import type { AppImageHookOptions, AppImageHookReturn } from '../types/interfaces'
// helpers
import { resolveStrapiMediaUrl, buildStrapiSrcset } from '@helpers/strapi-media'

const stripDevQuery = (url: string): string => url.split('?')[0] ?? ''

export const useAppImage = ({ props }: AppImageHookOptions): AppImageHookReturn => {
  const { public: { strapi } } = useRuntimeConfig()

  const refUsePicture = computed<boolean>(() => !props.media && Boolean(props.srcset))

  const refSrc = computed<string>(() => (
    props.media?.url
      ? resolveStrapiMediaUrl(props.media.url, strapi.publicUrl)
      : stripDevQuery(props.src ?? '')
  ))

  const refImgSrcset = computed<string>(() => (
    props.media ? buildStrapiSrcset(props.media, strapi.publicUrl) : ''
  ))

  const refAvifSrcset = computed<string>(() => (
    props.media ? '' : stripDevQuery(props.srcset ?? '')
  ))

  const refWidth = computed<string | number | undefined>(() => props.width ?? props.media?.width)
  const refHeight = computed<string | number | undefined>(() => props.height ?? props.media?.height)
  const refAlt = computed<string>(() => props.alt || props.media?.alternativeText || '')
  const refLoading = computed<'eager' | 'lazy'>(() => (props.priority ? 'eager' : 'lazy'))
  const refFetchpriority = computed<'high' | undefined>(() => (props.priority ? 'high' : undefined))

  return {
    refUsePicture,
    refSrc,
    refImgSrcset,
    refAvifSrcset,
    refWidth,
    refHeight,
    refAlt,
    refLoading,
    refFetchpriority,
  }
}
